<template>
  <div class="content-bg">
    <div class="footer">
      <div class="contact">
        <p class="add">
          备案号：
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            style="color: #F10F0F;"
          >桂ICP备2025076042号       桂公网安备45010502001130号</a>
        </p>
        <p class="copyright">版权所有&nbsp;&nbsp;&nbsp;&#169;广西壮族自治区粮油质量检验中心</p>
      </div>
      <div class="index-conpyright">
      
        <a href>
          <img
            style=" width: 70px;
    height: 40px;
    margin-right: 10px;" src="../styles/images/footer-logo.png"
          />
        </a>
      <a  href="https://bszs.conac.cn/sitename?method=show&id=D3E2E1CBB7AB385CE05310291AAC8285"  target="_blank"><img height="150vh" src="../styles/images/shiyedanwei.png"  /></a> 
      <img  src="../styles/images/copyright.png" />
    
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer"
};
</script>
<style scoped>
@import "../styles/home.css";
@import "../styles/pages.css";
@import "../styles/style.css";
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue